/**
 * Globe view chooser — 3D default, 2D fallback via `?view=2d` query param.
 * Keeps the 2D component as a stable fallback if WebGL/three is unavailable.
 */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import IntelligenceGlobe2D from "./IntelligenceGlobe";
import IntelligenceGlobe3D from "./IntelligenceGlobe3D";

function webglAvailable() {
  if (typeof window === "undefined") return false;
  try {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    return !!gl;
  } catch (_) {
    return false;
  }
}

export default function IntelligenceGlobeChooser() {
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);
  const force2d = params.get("view") === "2d";

  const [supports3d, setSupports3d] = useState(true);
  useEffect(() => {
    setSupports3d(webglAvailable());
  }, []);

  if (force2d || !supports3d) {
    return <IntelligenceGlobe2D />;
  }
  return <IntelligenceGlobe3D />;
}
